import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M7.08579 13.5H3.5C2.94772 13.5 2.5 13.0523 2.5 12.5V8.91421C2.5 8.649 2.60536 8.39464 2.79289 8.20711L8.29289 2.70711C8.68342 2.31658 9.31658 2.31658 9.70711 2.70711L13.2929 6.29289C13.6834 6.68342 13.6834 7.31658 13.2929 7.70711L7.79289 13.2071C7.60536 13.3946 7.351 13.5 7.08579 13.5Z"
            stroke="currentColor"
            strokeLinecap="round"
        />
        <circle cx="5" cy="11" fill="currentColor" r="1" />
    </svg>
);

export default Icon;
